import i18n from '../../locales/index'
import restful from '../vuex'
import { get } from 'lodash';

const state = {
  ...restful.states('users_shop')
}

const getters = {
  ...restful.getters('users_shop'),
  users_shop: state => {
    const data = state.users_shop;
    data.role_id = get(data, ['roles', 0, 'id'], null);
    return data;
  }
}

const actions = {
  ...restful.actions('users_shops')
}

const mutations = {
  ...restful.mutations('users_shop')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
